import { Caption } from '../../../../typography';
import { useTheme } from '../../../../theme';
import { InfoIcon } from '../../infoIcon';
import Box from '@mui/material/Box';

import type { JSX } from 'react';

type FormSubTextProps = {
  subText?: string;
  infoIconTitle?: string;
};

export const FormSubText = ({
  subText,
  infoIconTitle = '',
}: FormSubTextProps): JSX.Element | null => {
  const theme = useTheme();

  if (subText === undefined) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        height: '100%',
        justifyContent: 'left',
        alignItems: 'center',
        columnGap: theme.spacing(1),
      }}
    >
      <Caption color={theme.text.generic.tertiary} fontWeight='regular'>
        {subText}
      </Caption>
      {infoIconTitle && (
        <InfoIcon title={infoIconTitle} aria-label={infoIconTitle} />
      )}
    </Box>
  );
};
